module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/preface",
      "id": "ah1"
    }
  }, [_vm._v("Preface")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindentx"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right1",
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/chapter1",
      "id": "ah2"
    }
  }, [_vm._v("ONE")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "Art_pvii_1",
      "src": "Images/Art_Pvii_1.jpg"
    }
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/chapter1",
      "id": "ah3"
    }
  }, [_vm._v("Z"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRYAB")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/chapter1#page_1",
      "id": "ah4"
    }
  }, [_vm._v("The Slave Who Changed Society (Ninth Century)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindentx"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right1",
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/chapter2",
      "id": "ah5"
    }
  }, [_vm._v("TWO")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "Art_pvii_1",
      "src": "Images/Art_Pvii_1.jpg"
    }
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/chapter2",
      "id": "ah6"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AHOKIA")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/chapter2#page_19",
      "id": "ah7"
    }
  }, [_vm._v("The Forgotten Rome of the Americas (Twelfth Century)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindentx"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right1",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/chapter3",
      "id": "ah8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THREE")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "Art_pvii_1",
      "src": "Images/Art_Pvii_1.jpg"
    }
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/chapter3",
      "id": "ah9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IL")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANES")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/chapter3#page_41",
      "id": "ah10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conquering the Point of No Return (1434)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindentx"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right1",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/chapter4",
      "id": "ah11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FOUR")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "Art_pvii_1",
      "src": "Images/Art_Pvii_1.jpg"
    }
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/chapter4",
      "id": "ah12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSEPH")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARREN")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/chapter4#page_55",
      "id": "ah13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Architect of a Revolution (1741–75)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindentx"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right1",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/chapter5",
      "id": "ah14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FIVE")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "Art_pvii_1",
      "src": "Images/Art_Pvii_1.jpg"
    }
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/chapter5",
      "id": "ah15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTDOING")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EVERE")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/chapter5#page_85",
      "id": "ah16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("History’s Forgotten Riders (1777)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindentx"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right1",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/chapter6",
      "id": "ah17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SIX")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "Art_pvii_1",
      "src": "Images/Art_Pvii_1.jpg"
    }
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/chapter6",
      "id": "ah18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LISHA")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENT")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANE")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/chapter6#page_109",
      "id": "ah19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("America’s Greatest Hero (1847–57)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindentx"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right1",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/chapter7",
      "id": "ah20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SEVEN")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "Art_pvii_1",
      "src": "Images/Art_Pvii_1.jpg"
    }
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/chapter7",
      "id": "ah21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ULTANA")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/chapter7#page_135",
      "id": "ah22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Death on the Great River (1865)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindentx"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right1",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/chapter8",
      "id": "ah23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EIGHT")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "Art_pvii_1",
      "src": "Images/Art_Pvii_1.jpg"
    }
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/chapter8",
      "id": "ah24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MERICA’S")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRST")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UBWAY")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/chapter8#page_153",
      "id": "ah25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Secrets under Broadway (1870)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindentx"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right1",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/chapter9",
      "id": "ah26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NINE")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "Art_pvii_1",
      "src": "Images/Art_Pvii_1.jpg"
    }
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/chapter9",
      "id": "ah27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESHTIGO")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/chapter9#page_181",
      "id": "ah28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Great Fire in the Forest (1871)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindentx"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right1",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/chapter10",
      "id": "ah29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TEN")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "Art_pvii_1",
      "src": "Images/Art_Pvii_1.jpg"
    }
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/chapter10",
      "id": "ah30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("USTAVE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HITEHEAD")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/chapter10#page_207",
      "id": "ah31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The First to Fly? (1901)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindentx"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "right1",
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/chapter11",
      "id": "ah32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ELEVEN")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "Art_pvii_1",
      "src": "Images/Art_Pvii_1.jpg"
    }
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/chapter11",
      "id": "ah33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XERCISE")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGER")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/chapter11#page_229",
      "id": "ah34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Rehearsal for D-Day (1944)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindentx"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/acknowledgement",
      "id": "ah35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindentx"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/notes",
      "id": "ah36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindentx"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/bibliography",
      "id": "ah37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindentx"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindentx"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/Text/photocredit",
      "id": "ah38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Photo Credits")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-86c4cc94","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 75
// module chunks = 0